import React, { useState, useEffect, useCallback, useMemo } from 'react';
import styles from './index.less';
const CitysPart = (props) => {
  const { data = [], callBack } = props;
  return <div className={styles.citysPart}>
    <div className={styles.head}>
      <div className={styles.title}>请选择购票城市</div>
      <div className={styles.subTitle}>仅展示支持现场购票的城市</div>
    </div>
    <div className={styles.cityList}>
      {
        data?.map((str, index) => <div key={index} className={styles.item} onClick={() => { callBack && callBack(str); }}>
          {str}
        </div>)
      }
    </div>
  </div >;
};
export default CitysPart;
// export default MovieDetail

